export const environment = {
    production: false,
    apiBaseUrl: 'https://devapi.flwx.ai/api',
    stripePublishableKey: 'pk_test_kf2NtQMcNZ4AxofM4F8qnI7x00ihwKqyti'
};
